// eslint-disable-next-line no-unused-vars
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { browserHistory } from '@americanexpress/one-app-router';
// eslint-disable-next-line no-unused-vars
import { callFxgApi, FxComponentWrapper, FxJourneyCompletionPage } from 'axp-fx-common';
// eslint-disable-next-line no-unused-vars
import { ButtonPrimary, ButtonSecondary } from '@americanexpress/dls-react';
import { apiPaths, routes } from '../../../constants/paths';
import actionStatus from '../../../constants/actionStatus';
import { getActionHeading } from '../../../utils/journeyResponseUtil';
import labels from '../../../constants/labels';
import { environment } from '../../../constants/environment';

const UpdatePasswordResponse = ({
  updatedFxAccount,
  performAnotherActionButtonTxt,
  action,
}) => {
  const fxgApiHost = useSelector((state) => state.getIn(['config', 'fxgApi']));

  const [isApiCallCompleted, setIsApiCallCompleted] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [heading, setHeading] = useState('');

  const subHeading = (
    <p className="dls-gray-05">
      <span className="font-weight-bold">{`${labels.FX_ACCOUNT_NAME}: `}</span>
      {updatedFxAccount.fxAccountName}
    </p>
  );

  useEffect(() => {
    setHeading(getActionHeading(action, submitStatus));
  }, [action, submitStatus]);

  const updatePassword = async () => {
    setIsApiCallCompleted(false);
    const updPasswordReq = {
      reqId: updatedFxAccount.reqId,
      fxAccountId: updatedFxAccount.fxAccountId,
      fxAccountPassword: updatedFxAccount.password,
      environment: environment[updatedFxAccount.environment].shortName,
    };
    const { response, hasErrors } = await callFxgApi(
      `${fxgApiHost}${apiPaths.activateFxAccount}`,
      'POST',
      updPasswordReq
    );
    // if replication is success show success messsage
    if (!hasErrors && response?.data?.replicationStatus === 'success') {
      setSubmitStatus(actionStatus.SUCCESS);
    } else {
      setSubmitStatus(actionStatus.FAILED);
    }
    setIsApiCallCompleted(true);
  };

  useEffect(() => {
    const updatePasswordApi = async () => {
      await updatePassword();
    };
    updatePasswordApi();
  }, []); // updatePassword depends on props/state that won't change

  const onHomeButtonClick = () => {
    browserHistory.push(routes.home);
  };

  const onPrimaryButtonClick = () => {
    window.location.reload();
  };

  const actions = (
    <div className="margin-4-t">
      <ButtonSecondary
        className="margin-responsive-r"
        onClick={onHomeButtonClick}
      >
        Go to Homepage
      </ButtonSecondary>
      <ButtonPrimary onClick={onPrimaryButtonClick}>
        {performAnotherActionButtonTxt}
      </ButtonPrimary>
    </div>
  );

  return (
    <div className="margin-4-t">
      <FxComponentWrapper
        isError={false}
        isLoading={!isApiCallCompleted}
        loadedComponent={(
          <FxJourneyCompletionPage
            heading={heading}
            subHeading={subHeading}
            status={submitStatus}
            actions={actions}
          />
        )}
      />
    </div>
  );
};

UpdatePasswordResponse.propTypes = {
  updatedFxAccount: PropTypes.shape({
    reqId: PropTypes.number.isRequired,
    fxAccountId: PropTypes.number.isRequired,
    fxAccountName: PropTypes.string.isRequired,
    password: PropTypes.string.isRequired,
    environment: PropTypes.string.isRequired,
  }).isRequired,
  performAnotherActionButtonTxt: PropTypes.string.isRequired,
  action: PropTypes.string.isRequired,
};

export default UpdatePasswordResponse;
